import type { AnchorHTMLAttributes, ReactNode } from "react";
import { Link } from "react-router-dom";

type SmartLinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

export function SmartLink({ href, children, className, ...anchorProps }: SmartLinkProps) {
  const isExternal = href.startsWith("http") || href.startsWith("mailto:") || href.startsWith("#");

  if (isExternal) {
    return (
      <a className={className} href={href} {...anchorProps}>
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={href}>
      {children}
    </Link>
  );
}
